(ns ncr.etc.xform)

(defn create-xform
  "Creates stateless transducer from transduce-fn"
  [transduce-fn]
  (fn [rf]
    (fn
      ([] (rf))
      ([result] (rf result))
      ([result input]
       (transduce-fn input (partial rf result))))))

(defn create-simple-xform [input-fn]
  (create-xform (fn [input apply-fn] (apply-fn (input-fn input)))))

(defn create-through-xform [input-fn]
  (create-xform (fn [input apply-fn] (input-fn input) (apply-fn input))))

(defn create-empty-xform [input-fn]
  (create-xform (fn [input _] (input-fn input))))
